import { useState } from 'react';

interface Industry {
  name: string;
  description: string;
  image: string;
}

const industries: Industry[] = [
  {
    name: 'Real Estate',
    description: 'Lead generation, appointment setting, and administrative support for real estate professionals.',
    image: 'https://public.readdy.ai/ai/img_res/51a7e5275c55f4a811113f2ebbcb8f53.jpg'
  },
  {
    name: 'Solar & Energy',
    description: 'Sales support and customer outreach for renewable energy companies.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20solar%20panel%20installation%20on%20modern%20building%20rooftop%20with%20clean%20blue%20sky%2C%20renewable%20energy%20technology%20with%20sleek%20design%2C%20bright%20natural%20lighting%20with%20professional%20quality%2C%20simple%20clean%20background%20highlighting%20solar%20panels&width=500&height=700&seq=industry-solar-001&orientation=portrait'
  },
  {
    name: 'Insurance',
    description: 'Client management and policy administration support for insurance agencies.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20in%20modern%20office%20setting%20with%20insurance%20documents%2C%20corporate%20atmosphere%20with%20clean%20minimalist%20design%2C%20bright%20professional%20lighting%20with%20simple%20elegant%20background%2C%20trust%20and%20partnership%20concept&width=500&height=700&seq=industry-insurance-001&orientation=portrait'
  },
  {
    name: 'E-commerce',
    description: 'Customer service, order processing, and marketing support for online stores.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20e-commerce%20online%20shopping%20concept%20with%20packages%20and%20delivery%20boxes%2C%20clean%20minimalist%20product%20photography%20with%20professional%20quality%2C%20bright%20studio%20lighting%20with%20simple%20white%20background%2C%20organized%20business%20logistics%20theme&width=500&height=700&seq=industry-ecommerce-001&orientation=portrait'
  },
  {
    name: 'Marketing Agencies',
    description: 'Creative design, campaign management, and client coordination services.',
    image: 'https://readdy.ai/api/search-image?query=Creative%20marketing%20workspace%20with%20design%20tools%20and%20colorful%20brand%20materials%2C%20modern%20professional%20office%20environment%20with%20clean%20aesthetic%2C%20bright%20natural%20lighting%20with%20organized%20workspace%2C%20creative%20business%20atmosphere&width=500&height=700&seq=industry-marketing-001&orientation=portrait'
  },
  {
    name: 'Small & Medium Businesses',
    description: 'Comprehensive business support tailored to growing companies.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20small%20business%20team%20collaboration%20in%20modern%20office%2C%20diverse%20group%20working%20together%20with%20laptops%20and%20documents%2C%20bright%20natural%20lighting%20with%20clean%20minimalist%20workspace%2C%20productive%20business%20atmosphere&width=500&height=700&seq=industry-smb-001&orientation=portrait'
  }
];

export default function Industries() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="industries" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
          <p className="text-xl text-gray-600">Trusted by businesses across multiple sectors</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer group h-96"
            >
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={industry.image}
                  alt={industry.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-3xl font-bold mb-3">{industry.name}</h3>
                <p className={`text-gray-200 text-sm leading-relaxed transition-all duration-300 ${
                  hoveredIndex === index ? 'opacity-100 max-h-32' : 'opacity-0 max-h-0 overflow-hidden'
                }`}>
                  {industry.description}
                </p>
                <div className={`mt-4 transition-all duration-300 ${
                  hoveredIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}>
                  <span className="text-[#ffbd59] font-semibold flex items-center gap-2 whitespace-nowrap">
                    Learn More <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}